import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";
import { Row } from "@faire/web/slate/Layout";
import React from "react";

import { SDUISectionInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { FilterablePaginatedSectionSideBarRendererNonRSC } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Components/FilterablePaginatedSectionSideBarRendererNonRSC";
import { SDUIFilterablePaginatedSectionComponentsColumnNonRSC } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Components/SDUIFilterablePaginatedSectionComponentsColumnNonRSC";
import { FilterablePaginatedSectionWrapper } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/FilterablePaginatedSectionWrapper";
import { SDUIFilterStoreProvider } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/SDUIFilterStoreProvider";
import { SDUIFilterablePaginatedSectionPaginationNonRSC } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Pagination/SDUIFilterablePaginatedSectionPaginationNonRSC";
import { SDUIRetrievalQueriesNonRSC } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/RetrievalQueries/SDUIRetrievalQueriesNonRSC";

export const SDUIFilterablePaginatedSectionRenderer: React.FC<
  SDUISectionInstanceRendererProps
> = ({ section, ...rest }) => {
  const filterablePaginatedSection = section.filterable_paginated_section;
  if (filterablePaginatedSection) {
    return (
      <FilterablePaginatedSectionRenderer
        filterablePaginatedSection={filterablePaginatedSection}
        {...rest}
      />
    );
  }
  return null;
};

const FilterablePaginatedSectionRenderer: React.FC<
  Omit<SDUISectionInstanceRendererProps, "section"> & {
    filterablePaginatedSection: IFilterablePaginatedSection;
  }
> = ({
  filterablePaginatedSection,
  componentRenderers,
  sectionLoggingData,
}) => {
  return (
    <FilterablePaginatedSectionWrapper>
      <SDUIRetrievalQueriesNonRSC
        filterablePaginatedSection={filterablePaginatedSection}
      />
      <SDUIFilterStoreProvider
        filterablePaginatedSection={filterablePaginatedSection}
      >
        <Row>
          <FilterablePaginatedSectionSideBarRendererNonRSC
            filterablePaginatedSection={filterablePaginatedSection}
            sectionLoggingData={sectionLoggingData}
          />
          <SDUIFilterablePaginatedSectionComponentsColumnNonRSC
            filterablePaginatedSection={filterablePaginatedSection}
            componentRenderers={componentRenderers}
            sectionLoggingData={sectionLoggingData}
          />
        </Row>
        <SDUIFilterablePaginatedSectionPaginationNonRSC
          filterablePaginatedSection={filterablePaginatedSection}
          sectionLoggingData={sectionLoggingData}
        />
      </SDUIFilterStoreProvider>
    </FilterablePaginatedSectionWrapper>
  );
};
